import React from 'react'
import "./car.css"
export default class Car extends React.Component {
    render() {
        return (
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            }}>
            <svg xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="400px" height="300px" viewBox="-20 0 400 300">
            <defs>
                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style={{stopColor: "rgb(0,255,255)", stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor: "rgb(0,0,255)", stopOpacity:1}} />
                </linearGradient>
                <rect id="bar" x="-2.5" y="145" width="6" height="20" fill="white" stroke="grey" strokeWidth="1"/>

                <g id="wheel">
                    <circle cy="145" r="25" fill="none" stroke="black" strokeWidth="10"/>
                    <use xlinkHref="#bar" transform="rotate(30 0 145)"></use>
                    <use xlinkHref="#bar" transform="rotate(100 0 145)"></use>
                    <use xlinkHref="#bar" transform="rotate(170 0 145)"></use>
                    <use xlinkHref="#bar" transform="rotate(240 0 145)"></use>
                    <use xlinkHref="#bar" transform="rotate(310 0 145)"></use>
                    <circle cy="145" r="5" fill="white" stroke="black" strokeWidth="4"/>
                </g>

                <g id="car">
                <g id="carrosserie">

                        
                    <path d="M 2.5 150 q -30 -70 80 -70
                    Q 100 50 130 30
                    q 150 -20 170 20
                    Q 338.5 130 320 150
                    M 320 150 H 310
                    M 250 150 H 95
                    M 35 150 H 0
                    "
                    fill="url(#grad1)" stroke="black" strokeWidth="3" />
                    
                    
                    
                   {/*  <!-- First door --> */}
                    <path d="M 90 75 L 190 75 L 190 35 Q 160 35 130 40 Q 110 50 90 75" fill="white" stroke="black" strokeWidth="2"/>
                    <path d="M 90 75 L 190 75 L 190 35 Q 160 35 130 40 Q 110 50 90 75" fill="rgba(0,0,0,0.8)" stroke="black" strokeWidth="2"/>
                    <path d="M 90 85 L 190 85 L 190 145 L 110 145" fill="none" stroke="black" strokeWidth="2"/>
                    <path d="M 110 145 Q 70 90 90 85" fill="none" strokeWidth="2" stroke="black" />
                    
                    {/* <!-- Second door --> */}
                    <path d="M 200 75 L 295 75 Q 295 50 260 35 L 200 35 L 200 75" fill="white" stroke="black" strokeWidth="2"/>
                    <path d="M 200 75 L 295 75 Q 295 50 260 35 L 200 35 L 200 75" fill="rgba(0,0,0,0.8)" stroke="black" strokeWidth="2"/>
                    <path d="M 200 85 L 295 85 L 295 100 " fill="none" stroke="black" strokeWidth="2"/>
                    <path d="M 295 100 q -50 0 -55 45" fill="none" strokeWidth="2" stroke="black" />
                    <path d="M 240 145 H 200 V 85" fill="none" strokeWidth="2" stroke="black" />

                    <path d="M 30 90 L 35 110 L 5 110 Q 15 90 35 90" fill="white" />
                    <path d="M 30 90 V 110 H 40 V 90" fill="orange" />
                    
                </g>
                    
                    <use id="wheel1" xlinkHref="#wheel" x="65"></use>
                    <use id="wheel2" xlinkHref="#wheel" x="280"></use>
                </g>
                </defs>
                
                <use xlinkHref="#car" ></use>
            </svg>
            
        </div>
        )
    }
}